module.exports = new __parcel__URL__("schillerplatz.2d746c54.jpeg").toString();